import React from 'react';

const PrivacyPolicyPT: React.FC = () => {
  return (
    <div className="prose max-w-none">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Introdução</h2>
        <p className="mb-4">
          A BIXMO SRL ("nós," "nosso," ou "conosco") opera o aplicativo móvel e site GatherPlay (o "Serviço"). 
          Esta Política de Privacidade explica como coletamos, usamos e protegemos informações quando você usa nosso Serviço.
        </p>
        <div className="bg-gray-100 p-4 rounded-lg mb-4">
          <p><strong>Informações de contato:</strong></p>
          <ul className="list-none mt-2 space-y-1">
            <li>Empresa: BIXMO SRL</li>
            <li>Endereço: Chisinau, Moldova</li>
            <li>Email: gatherplay.application@gmail.com</li>
          </ul>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Informações que coletamos</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">2.1 Informações que NÃO coletamos</h3>
        <p className="mb-4">
          O GatherPlay é projetado com a privacidade em mente. Não exigimos registro de usuário e não coletamos informações pessoais como:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Nomes, endereços de email ou números de telefone</li>
          <li>Informações demográficas</li>
          <li>Dados de localização além de análises básicas no nível do país</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">2.2 Informações que coletamos</h3>
        <p className="mb-3"><strong>Informações coletadas automaticamente:</strong></p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li><strong>Informações do dispositivo:</strong> Tipo de dispositivo, versão do sistema operacional, versão do aplicativo</li>
          <li><strong>Análises de uso:</strong> Como você interage com o aplicativo, recursos utilizados, duração da sessão (coletado via Amplitude)</li>
          <li><strong>Dados técnicos:</strong> Relatórios de falhas e métricas de desempenho para melhorar a estabilidade do aplicativo</li>
        </ul>

        <p className="mb-3"><strong>Armazenamento local do dispositivo:</strong></p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li><strong>ID do jogador:</strong> Um identificador gerado aleatoriamente armazenado localmente em seu dispositivo para garantir que os cenários do jogo não se repitam para o mesmo jogador</li>
          <li><strong>Preferências do jogo:</strong> Configurações e preferências que você configura no aplicativo</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Como usamos as informações</h2>
        <p className="mb-4">Usamos as informações coletadas para:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Melhorar o desempenho do aplicativo e corrigir bugs</li>
          <li>Entender como os usuários interagem com o GatherPlay para aprimorar a experiência de jogo</li>
          <li>Garantir que os cenários do jogo não se repitam para jogadores individuais</li>
          <li>Exibir anúncios relevantes (na versão gratuita)</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Compartilhamento e divulgação de informações</h2>
        <p className="mb-3"><strong>Serviços de terceiros:</strong></p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li><strong>Amplitude:</strong> Usamos o Amplitude para análises para entender o uso do aplicativo e melhorar a experiência do usuário</li>
          <li><strong>Google Ads:</strong> Exibimos anúncios através da rede publicitária do Google na versão gratuita do aplicativo</li>
          <li><strong>Lojas de aplicativos:</strong> Estatísticas básicas de uso podem ser compartilhadas com a Apple App Store e Google Play Store como parte de suas análises padrão</li>
        </ul>
        <p>Não vendemos, trocamos ou transferimos suas informações para terceiros além desses provedores de serviços.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Publicidade</h2>
        <p>
          A versão gratuita do GatherPlay exibe anúncios fornecidos pelo Google Ads. Esses anúncios podem ser baseados em dados demográficos 
          gerais e interesses, mas não usam informações pessoais coletadas do nosso aplicativo. Você pode fazer upgrade para a versão premium 
          para remover todos os anúncios através de uma compra no aplicativo.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Segurança de dados</h2>
        <p>
          Implementamos medidas técnicas e organizacionais apropriadas para proteger informações contra acesso não autorizado, 
          alteração, divulgação ou destruição. Como coletamos dados mínimos, seu risco de privacidade é significativamente reduzido.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Privacidade de crianças</h2>
        <p>
          O GatherPlay é adequado para usuários de 6 anos ou mais. Não coletamos conscientemente informações pessoais de crianças. 
          Se você é pai ou responsável e acredita que seu filho nos forneceu informações pessoais, entre em contato conosco em 
          gatherplay.application@gmail.com.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Retenção de dados</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Dados de análise:</strong> Retidos por até 2 anos para analisar tendências e melhorar o serviço</li>
          <li><strong>Dados locais do dispositivo:</strong> Armazenados localmente em seu dispositivo e podem ser limpos desinstalando o aplicativo</li>
          <li><strong>Dados técnicos:</strong> Relatórios de falhas e dados de desempenho retidos por até 1 ano</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Seus direitos</h2>
        <p className="mb-4">Você tem o direito de:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Solicitar informações sobre quais dados coletamos (limitado conforme descrito acima)</li>
          <li>Solicitar a exclusão de seus dados entrando em contato conosco</li>
          <li>Optar por não participar das análises desabilitando-as nas configurações do seu dispositivo</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Transferências internacionais de dados</h2>
        <p>
          Nosso provedor de análises (Amplitude) pode processar dados em países diferentes da Moldova. Garantimos que as salvaguardas 
          apropriadas estejam em vigor para quaisquer transferências internacionais de dados.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Alterações a esta Política de Privacidade</h2>
        <p>
          Podemos atualizar esta Política de Privacidade de tempos em tempos. Notificaremos você sobre quaisquer alterações postando a nova 
          Política de Privacidade no aplicativo e atualizando a data "Última atualização". O uso continuado do Serviço após 
          as alterações constitui aceitação da política atualizada.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Entre em contato conosco</h2>
        <p className="mb-4">Se você tiver alguma dúvida sobre esta Política de Privacidade, entre em contato conosco:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Email: gatherplay.application@gmail.com</li>
          <li>Empresa: BIXMO SRL, Chisinau, Moldova</li>
        </ul>
      </section>

      <div className="bg-blue-50 p-4 rounded-lg mt-8">
        <p className="text-sm text-blue-800">
          Esta Política de Privacidade foi desenvolvida para ser transparente sobre nossas práticas mínimas de coleta de dados enquanto 
          garante o cumprimento das leis de privacidade aplicáveis, incluindo GDPR, CCPA e requisitos das lojas de aplicativos móveis.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPT;